export const LABELS = {
  PHONE_PATTERN: /^\(?([0-9]{3})\)?[-.\s]?([0-9]{3})[-.\s]?([0-9]{4})$/,
  EMAIL_PTTERN: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  NUMBER_PATTERN: /^[^0-9]+$/,
  NUMBERS_ONLY: /^[0-9]+$/, 
  ALPHABETS_NUMBER_PATTERN: /^[A-Za-zÀ-ÿ0-9]+$/,
  SPECIAL_CHARECTER: /^[A-Za-zÀ-ÿ0-9]+$/,
  ERROR_MESSAGES : {
    required: 'Required',
    minlength: 'Too short',
    maxlength: 'Too Long',
    invalidDateFormat: 'Please enter a valid date',
    checkboxInvalid: 'Checkbox invalid',
    radioInvalid: 'Radio invalid',
    email: 'Please enter a valid email',
    phone: ' Please enter a valid phone (XXX) XXX-XXXX',
    mismatch: "Passwords don't match",
    customFieldValidation : "Please enter a valid value",
    minimumNineCharecter: 'Please enter a minimum of 9 characters',
    minimumSixCharecter: 'Please enter a minimum of 6 characters',
    minimumFiveCharecter: 'Please enter a minimum of 5 characters',
    maxAddressAndName: 'More than 255 characters are not allowed',
    maxCity: 'More than 150 characters are not allowed',
    maxAddress: 'More than 55 characters are not allowed',
    maxName: 'More than 80 characters are not allowed',
  },
  STATE_CODES_LIST:  [
    { value: 'AL', viewValue: 'Alabama' },
    { value: 'AK', viewValue: 'Alaska' },
    { value: 'AZ', viewValue: 'Arizona' },
    { value: 'AR', viewValue: 'Arkansas' },
    { value: 'CA', viewValue: 'California' },
    { value: 'CO', viewValue: 'Colorado' },
    { value: 'CT', viewValue: 'Connecticut' },
    { value: 'DE', viewValue: 'Delaware' },
    { value: 'DC', viewValue: 'District of Columbia' },
    { value: 'FL', viewValue: 'Florida' },
    { value: 'GA', viewValue: 'Georgia' },
    { value: 'HI', viewValue: 'Hawaii' },
    { value: 'ID', viewValue: 'Idaho' },
    { value: 'IL', viewValue: 'Illinois' },
    { value: 'IN', viewValue: 'Indiana' },
    { value: 'IA', viewValue: 'Iowa' },
    { value: 'KS', viewValue: 'Kansas' },
    { value: 'KY', viewValue: 'Kentucky' },
    { value: 'LA', viewValue: 'Louisiana' },
    { value: 'ME', viewValue: 'Maine' },
    { value: 'MD', viewValue: 'Maryland' },
    { value: 'MA', viewValue: 'Massachusetts' },
    { value: 'MI', viewValue: 'Michigan' },
    { value: 'MN', viewValue: 'Minnesota' },
    { value: 'MS', viewValue: 'Mississippi' },
    { value: 'MO', viewValue: 'Missouri' },
    { value: 'MT', viewValue: 'Montana' },
    { value: 'NE', viewValue: 'Nebraska' },
    { value: 'NV', viewValue: 'Nevada' },
    { value: 'NH', viewValue: 'New Hampshire' },
    { value: 'NJ', viewValue: 'New Jersey' },
    { value: 'NM', viewValue: 'New Mexico' },
    { value: 'NY', viewValue: 'New York' },
    { value: 'NC', viewValue: 'North Carolina' },
    { value: 'ND', viewValue: 'North Dakota' },
    { value: 'OH', viewValue: 'Ohio' },
    { value: 'OK', viewValue: 'Oklahoma' },
    { value: 'OR', viewValue: 'Oregon' },
    { value: 'PA', viewValue: 'Pennsylvania' },
    { value: 'RI', viewValue: 'Rhode Island' },
    { value: 'SC', viewValue: 'South Carolina' },
    { value: 'SD', viewValue: 'South Dakota' },
    { value: 'TN', viewValue: 'Tennessee' },
    { value: 'TX', viewValue: 'Texas' },
    { value: 'UT', viewValue: 'Utah' },
    { value: 'VT', viewValue: 'Vermont' },
    { value: 'VA', viewValue: 'Virginia' },
    { value: 'WA', viewValue: 'Washington' },
    { value: 'WV', viewValue: 'West Virginia' },
    { value: 'WI', viewValue: 'Wisconsin' },
    { value: 'WY', viewValue: 'Wyoming' }
  ]
}